const { notificationPanelComponentDefinition } = require('./notification-panel.component');

require('angular').module('wowApp.shop')
    .component('wowNotificationPanel', notificationPanelComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/notificationpanel/index.js